import { Route, Switch } from 'react-router';

import { useAppSelector } from './hooks';
import { Home } from '../features/home/Home';
import { Login } from '../features/auth/Login';
import { SignUp } from '../features/auth/SignUp';
import { TenantCreatePage } from '../features/tenant/TenantCreatePage';
import { TenantViewPage } from '../features/tenant/TenantViewPage';
import { TenantEditPage } from '../features/tenant/TenantEditPage';
import { RoleListPage } from '../features/role/RoleListPage';
import { RolePage } from '../features/role/RolePage';
import { MemberListPage } from '../features/member/MemberListPage';
import { MemberPage } from '../features/member/MemberPage';
import { ClientListPage } from '../features/client/ClientListPage';
import { ClientPage } from '../features/client/ClientPage';
import { ScopeListPage } from '../features/scope/ScopeListPage';
import { ScopePage } from '../features/scope/ScopePage';
import { selectCurrentTenantId } from '../features/user/userSlice';
import { route_path } from './route';
import { SetPasswordCallback } from '../features/auth/SetPasswordCallback';


export function AppRoute() {
  let current_tenant_id = useAppSelector(selectCurrentTenantId);
  if (!current_tenant_id) {
    return (
      <Switch>
        <Route exact strict path={route_path.login} component={Login} />
        <Route exact strict path={route_path.signup} component={SignUp} />
        <Route exact strict path={route_path.signup_callback} component={SetPasswordCallback} />
        <Route exact strict path={route_path.forgot_password_callback} component={SetPasswordCallback} />
        <Route exact strict path={route_path.tenant_create} component={TenantCreatePage} />
      </Switch>
    );
  }
  return (
    <Switch>
      <Route exact strict path={route_path.tenant_create} component={TenantCreatePage} />
      <Route exact strict path={route_path.tenant_view} component={TenantViewPage} />
      <Route exact strict path={route_path.tenant_edit} component={TenantEditPage} />
      <Route exact strict path={route_path.role_list} component={RoleListPage} />
      <Route exact strict path={route_path.role_detail} component={RolePage} />
      <Route exact strict path={route_path.member_list} component={MemberListPage} />
      <Route exact strict path={route_path.member_detail} component={MemberPage} />
      <Route exact strict path={route_path.client_list} component={ClientListPage} />
      <Route exact strict path={route_path.client_detail} component={ClientPage} />
      <Route exact strict path={route_path.scope_list} component={ScopeListPage} />
      <Route exact strict path={route_path.scope_detail} component={ScopePage} />
      <Route component={Home} />
    </Switch>
  );
}
